import { EmptySection } from '../components/Card.jsx';

/* TODO: opening times per day (Europe/London) plus holidays.
   Tenant admin only. */
export default function BusinessHours() {
  return (
    <EmptySection
      title="Business hours"
      body="Your opening times and holidays will appear here, and feed the business-hours check in your call routing."
    />
  );
}
